{
  "nome": "SAGRA DI SAN LUIGI 2026",
  "edizione": "46ª Edizione",
  "luogo": "Beccacivetta di Castel d'Azzano",
  "date": "dal 5 al 9 Giugno 2026",
  "info": "Organizzata da BECCUP · #faisagraconnoi",
  "extra": "Nel salone parrocchiale: pesca di beneficenza e mostra fotografica",
  "stands": [
    {
      "id": 1,
      "nome": "Primi",
      "icon": "utensils",
      "zona": "Circolo NOI",
      "sezione": "PRIMI",
      "piatti": [
        {
          "nome": "Risotto all'isolana",
          "prezzo": 6,
          "allergeni": [
            "glutine",
            "latte",
            "sedano"
          ]
        },
        {
          "nome": "Maccheroncini con pesto di rucola",
          "prezzo": 6,
          "allergeni": [
            "glutine",
            "fruttasguscio"
          ]
        },
        {
          "nome": "Maccheroncini con ragù di cortile",
          "prezzo": 7,
          "allergeni": [
            "glutine",
            "uova",
            "sedano"
          ]
        },
        {
          "nome": "Maccheroncini col musso",
          "prezzo": 7,
          "allergeni": [
            "glutine",
            "sedano"
          ]
        }
      ]
    },
    {
      "id": 2,
      "nome": "Grigliata & Secondi",
      "icon": "grill",
      "zona": "Circolo NOI",
      "sezione": "SECONDI",
      "isNew": true,
      "piatti": [
        {
          "nome": "Polenta e pancetta + contorno",
          "prezzo": 10,
          "allergeni": []
        },
        {
          "nome": "Polenta e salsiccia + contorno",
          "prezzo": 6,
          "allergeni": []
        },
        {
          "nome": "Pollo e patatine",
          "prezzo": 9,
          "allergeni": []
        },
        {
          "nome": "Chili con carne",
          "prezzo": 9,
          "allergeni": [
            "sedano"
          ]
        },
        {
          "nome": "Piadina con crudo e fontina",
          "prezzo": 5.5,
          "allergeni": [
            "glutine",
            "latte"
          ]
        },
        {
          "nome": "Grigliata mista",
          "prezzo": 10,
          "allergeni": []
        },
        {
          "nome": "Costine con patatine",
          "prezzo": 10,
          "allergeni": []
        },
        {
          "nome": "Arrosticini (5 pz.)",
          "prezzo": 6,
          "isNew": true,
          "allergeni": []
        },
        {
          "nome": "Arrosticini (10 pz.)",
          "prezzo": 10,
          "isNew": true,
          "allergeni": []
        },
        {
          "nome": "Caprese con mozzarella di bufala",
          "prezzo": 5,
          "allergeni": [
            "latte"
          ]
        },
        {
          "nome": "Carne salà con rucola e grana",
          "prezzo": 8,
          "allergeni": [
            "latte"
          ]
        }
      ]
    },
    {
      "id": 8,
      "nome": "Pizzeria Belsito",
      "icon": "pizza",
      "zona": "Dopo il Bar Centrale",
      "sezione": "PIZZA",
      "piatti": [
        {
          "nome": "Pizza Margherita",
          "prezzo": 6,
          "allergeni": [
            "glutine",
            "latte"
          ]
        },
        {
          "nome": "Pizza Farcita",
          "prezzo": 8.5,
          "allergeni": [
            "glutine",
            "latte",
            "uova"
          ]
        }
      ]
    },
    {
      "id": 4,
      "nome": "Bimbi & Contorni",
      "icon": "child",
      "zona": "Circolo NOI",
      "sezione": "BIMBI & CONTORNI",
      "note": "(*prodotto surgelato)",
      "piatti": [
        {
          "nome": "Happy Sagra (crocchette pollo + patatine fritte)",
          "prezzo": 6,
          "allergeni": [
            "glutine",
            "uova"
          ]
        },
        {
          "nome": "Patatine fritte*",
          "prezzo": 4.5,
          "allergeni": []
        },
        {
          "nome": "Verdure grigliate",
          "prezzo": 3,
          "allergeni": []
        }
      ]
    },
    {
      "id": 5,
      "nome": "Dolci",
      "icon": "cake",
      "zona": "Circolo NOI",
      "sezione": "DOLCI",
      "piatti": [
        {
          "nome": "Dolce",
          "prezzo": 3,
          "allergeni": [
            "glutine",
            "uova",
            "latte",
            "fruttasguscio"
          ]
        },
        {
          "nome": "Sbrisolona intera",
          "prezzo": 5,
          "allergeni": [
            "glutine",
            "uova",
            "fruttasguscio"
          ]
        },
        {
          "nome": "Sbrisolona intera + grappa",
          "prezzo": 7,
          "allergeni": [
            "glutine",
            "uova",
            "fruttasguscio"
          ]
        }
      ]
    },
    {
      "id": 6,
      "nome": "Bar & Bevande",
      "icon": "beer",
      "zona": "Bar Centrale",
      "sezione": "BEVANDE",
      "note": "Cauzione caraffa €5",
      "piatti": [
        {
          "nome": "Birra alla spina",
          "prezzo": 4.5,
          "allergeni": [
            "glutine"
          ]
        },
        {
          "nome": "Birra alla spina non filtrata",
          "prezzo": 4.5,
          "allergeni": [
            "glutine"
          ]
        },
        {
          "nome": "Promo 5 birre",
          "prezzo": 20,
          "allergeni": [
            "glutine"
          ]
        },
        {
          "nome": "Bibita in lattina",
          "prezzo": 2.5,
          "allergeni": []
        },
        {
          "nome": "Acqua 0,5 litri",
          "prezzo": 1,
          "allergeni": []
        },
        {
          "nome": "Vino sfuso 0,5 litri",
          "prezzo": 4,
          "allergeni": [
            "solfiti"
          ]
        },
        {
          "nome": "Vino sfuso 1 litro",
          "prezzo": 8,
          "allergeni": [
            "solfiti"
          ]
        },
        {
          "nome": "Bicchiere di vino",
          "prezzo": 1,
          "allergeni": [
            "solfiti"
          ]
        },
        {
          "nome": "Caffè",
          "prezzo": 2,
          "allergeni": []
        },
        {
          "nome": "Caffè corretto",
          "prezzo": 2,
          "allergeni": []
        },
        {
          "nome": "Amari",
          "prezzo": 3.5,
          "allergeni": [
            "solfiti"
          ]
        }
      ]
    },
    {
      "id": 7,
      "nome": "Fuori Sagra — Gin Corner",
      "icon": "cocktail",
      "zona": "Campo",
      "sezione": "COCKTAIL & APERITIVO",
      "note": "Cauzione caraffa €5",
      "piatti": [
        {
          "nome": "EL PANETO (panino salamella, peperoni, cipolla e salse)",
          "prezzo": 5,
          "allergeni": [
            "glutine",
            "sedano"
          ]
        },
        {
          "nome": "Spritz bianco",
          "prezzo": 2.5,
          "allergeni": [
            "solfiti"
          ]
        },
        {
          "nome": "Spritz (Aperol / Campari)",
          "prezzo": 4,
          "allergeni": [
            "solfiti"
          ]
        },
        {
          "nome": "Alberello Campari",
          "prezzo": 2.5,
          "allergeni": []
        },
        {
          "nome": "Americano / Negroni",
          "prezzo": 5,
          "allergeni": []
        },
        {
          "nome": "Negroni",
          "prezzo": 6,
          "allergeni": []
        },
        {
          "nome": "Americano / Negroni (caraffa)",
          "prezzo": 20,
          "allergeni": []
        },
        {
          "nome": "Gin Lemon / Gin Tonic",
          "prezzo": 5,
          "allergeni": []
        },
        {
          "nome": "Verdone / Vodka Tonic / Campari Lemon",
          "prezzo": 5,
          "allergeni": []
        },
        {
          "nome": "Pestati (Mojito, Caipiroska fragola…)",
          "prezzo": 6,
          "allergeni": []
        },
        {
          "nome": "Paloma",
          "prezzo": 6,
          "allergeni": []
        },
        {
          "nome": "Caxxo di cane",
          "prezzo": 6,
          "allergeni": []
        },
        {
          "nome": "Energy Drink",
          "prezzo": 3.5,
          "allergeni": []
        },
        {
          "nome": "Birra alla spina",
          "prezzo": 4.5,
          "allergeni": [
            "glutine"
          ]
        },
        {
          "nome": "Birra non filtrata",
          "prezzo": 4.5,
          "allergeni": [
            "glutine"
          ]
        },
        {
          "nome": "Promo 5 birre",
          "prezzo": 20,
          "allergeni": [
            "glutine"
          ]
        },
        {
          "nome": "Acqua",
          "prezzo": 1,
          "allergeni": []
        },
        {
          "nome": "Panino salsiccia peperoni cipolla e salse",
          "prezzo": 5,
          "allergeni": [
            "glutine",
            "sedano"
          ]
        },
        {
          "nome": "Gin Tonic Standard",
          "prezzo": 8,
          "allergeni": []
        },
        {
          "nome": "Gin Tonic Premium",
          "prezzo": 10,
          "allergeni": []
        }
      ]
    }
  ],
  "serate": [
    {
      "giorno": "Venerdì 5 Giugno",
      "data": "2026-06-05",
      "artista": "DISCO FEVER SHOW",
      "image": "/serate live/logo-discofever-show-256x300.webp",
      "genere": "Musica Disco & Anni '70",
      "orario": "21:30",
      "djset": "DJ NICOLA BERARDO",
      "imageDj": "/djSet/djberardo_instagram.png"
    },
    {
      "giorno": "Sabato 6 Giugno",
      "data": "2026-06-06",
      "artista": "CIRCOMAX 883 TRIBUTE SHOW",
      "image": "/serate live/800_65fc443da8c2d_filter_65fc446d58ee8.jpg.webp",
      "genere": "Tribute agli 883",
      "orario": "21:30",
      "djset": "DJ LOLLO",
      "imageDj": "/djSet/djLollo_instagram.png"
    },
    {
      "giorno": "Domenica 7 Giugno",
      "data": "2026-06-07",
      "artista": "Orchestra MATTIA AGOSTINI",
      "image": "/serate live/Unknown-2.jpg",
      "genere": "Serata danzante",
      "orario": "21:00",
      "djset": "DJ LADY D",
      "note": "Serata sponsorizzata da AVIS",
      "imgPlus": "",
      "imageDj": "/djSet/djLadyD_instagram.png"
    },
    {
      "giorno": "Lunedì 8 Giugno",
      "data": "2026-06-08",
      "artista": "Orchestra LARA AGOSTINI",
      "image": "/serate live/LaraAgostini.jpg",
      "genere": "Serata danzante",
      "orario": "21:00",
      "djset": "DJ LEONARDO FORIGO",
      "imageDj": "/djSet/djFRG_instagram.png"
    },
    {
      "giorno": "Martedì 9 Giugno",
      "data": "2026-06-09",
      "artista": "DYNAMICA PARTY BAND",
      "image": "serate live/Unknown.jpg",
      "genere": "Serata di musica",
      "orario": "21:30",
      "djset": "DJ DOMUS D",
      "note": "Apertura serata Operazione Sbrinamento PTN dalle 20:30-21:30",
      "imgPlus": "",
      "imageDj": "/djSet/djDomus_instagram.png"
    }
  ],
  "casse": [
    {
      "id": 1,
      "nome": "Cassa Principale",
      "zona": "Ingresso",
      "desc": "Pagamento per tutti i piatti e bevande."
    },
    {
      "id": 2,
      "nome": "Bar Centrale",
      "zona": "Bar",
      "desc": "Bevande e caffetteria · Cauzione caraffa €5"
    },
    {
      "id": 3,
      "nome": "Cassa Fuori Sagra",
      "zona": "Campo esterno (TIHS RAB)",
      "desc": "Solo Cocktail, birre e panini · Aperitivo dalle 19:30"
    }
  ],
  "associazioni": [
    {
      "nome": "parrocchia",
      "descrizione": "Parrocchia Santa Maria Annunziata di Beccacivetta",
      "immagine": "/associazioni/parrocchia.jpg"
    },
    {
      "nome": "croceverde",
      "descrizione": "Croce Verde",
      "immagine": "/associazioni/Gemini_Generated_Image_jnmcskjnmcskjnmc.png"
    },
    {
      "nome": "piosi",
      "descrizione": "I Piosi - Cooperativa Sociale Sommacampagna",
      "immagine": "/associazioni/piosi.png"
    },
    {
      "nome": "matogrosso",
      "descrizione": "L' Operazione Mato Grosso (OMG) - ASFA Verona",
      "immagine": "/associazioni/matogrosso.jpg"
    },
    {
      "nome": "agbd",
      "descrizione": "AgbD: Associazione Onlus Sindrome di Down - Verona",
      "immagine": "/associazioni/agbd.jpg"
    },
    {
      "nome": "avis",
      "descrizione": "Associazione AVIS Castel d'Azzano",
      "immagine": "/associazioni/avis.png"
    },
    {
      "nome": "equo",
      "descrizione": "Mercato EQUO Solidale",
      "immagine": "/associazioni/equo.png"
    }
  ]
}